import LocalePromoBar from 'models/LocalePromoBar';

export enum Positions {
    Relative = 'relative',
    Fixed = 'fixed',
}
export interface Props {
    articlePromoContent: LocalePromoBar;
    position: string;
    sectionId?: string;
    promobarInitalTopOffset?: number;
}

export interface Translations {
    successfullyAdded: string;
}
